(function () {
  'use strict';

  angular.module('estClipboard').service('estClipboard', estClipboard);

  estClipboard.$inject = ['$mdToast', '$translate', '$rootScope'];

  function estClipboard(
    /** @type {angular.material.IToastService} */ $mdToast,
    $translate,
    $rootScope,
  ) {
    var text = $translate.instant('general.copied');

    $rootScope.$on('$translateChangeSuccess', function () {
      text = $translate.instant('general.copied');
    });

    var success = function (e) {
      $mdToast.show(
        $mdToast
          .simple()
          .textContent(text)
          .position('bottom right')
          .hideDelay(1500),
      );
    };

    var error = function (e) {
      console.log('Unable to copy to clipboard');
    };

    return {
      onSuccess: success,
      onError: error,
    };
  }
})();
